import React, { useState } from "react";
import { Alert, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Contact: React.FC = () => {
  const [errorMsg, setErrorMsg] = useState("");

  const { t } = useTranslation();
  const handleSubmit = (event: any) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    // Access form field values
    const name = formData.get("name");
    const email = formData.get("email");
    const comments = formData.get("comments");

    const validationError = validateForm(name, email, comments);
    if (validationError) {
      setErrorMsg(validationError);
      return;
    }
    form.reset();
    setErrorMsg("");
  };

  const validateForm = (name: any, email: any, comments: any) => {
    if (!name || name.trim() === "") {
      return t("contact.pleaseEnterName");
    }
    if (!email || email.trim() === "") {
      return t("contact.pleaseEnterEmail");
    }
    if (!comments || comments.trim() === "") {
      return t("contact.pleaseEnterComments");
    }
    return "";
  };

  return (
    <React.Fragment>
      <section className="section" id="contact">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center">
                <h2
                  className="heading-title-title text-uppercase"
                  style={{ fontSize: "40px" }}
                >
                  {t("contact.getInTouch")}
                </h2>
              </div>
            </Col>
          </Row>

          <div className="row mt-5 pt-4">
            <Col lg={6}>
              <div className="startup-map mt-4">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3723.345657866797!2d46.8462944!3d24.6682224!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f0389!2sLocationName!5e0!3m2!1sen!2s!4v1699876543210!5m2!1sen!2s"
                  height="350"
                  style={{ border: 0, width: "100%" }}
                  allowFullScreen
                  title="Google Map"
                ></iframe>
              </div>
            </Col>

            <Col lg={6}>
              <div className="custom-form mt-3">
                <form
                  method="post"
                  onSubmit={handleSubmit}
                  className="contact-form"
                  name="myForm"
                  id="myForm"
                >
                  {errorMsg && (
                    <Alert variant="danger" className="error_message">
                      {errorMsg}*
                    </Alert>
                  )}
                  <Row>
                    <Col lg={6}>
                      <div className="form-group mt-3">
                        <Form.Control
                          name="name"
                          id="name"
                          type="text"
                          placeholder={t("contact.placeholderName")}
                        />
                      </div>
                    </Col>

                    <Col lg={6}>
                      <div className="form-group mt-3">
                        <Form.Control
                          name="email"
                          id="email"
                          type="email"
                          placeholder={t("contact.placeholderEmail")}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <div className="form-group mt-3">
                        <Form.Control
                          as="textarea"
                          name="comments"
                          id="comments"
                          rows={8}
                          placeholder={t("contact.placeholderMessage")}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <div className="mt-3">
                        <input
                          type="submit"
                          id="submit"
                          name="send"
                          className="submitBnt btn btn-dark-custom"
                          value={t("contact.sendMessage")}
                        />
                        <div id="simple-msg"></div>
                      </div>
                    </Col>
                  </Row>
                </form>
              </div>
            </Col>
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Contact;
